import React from 'react'

const Skeleton = () => {
    return (
        <div className="grid md:grid-cols-2 gap-x-4 mt-3">
            <div className="w-full h-10 bg-[#2D4F71] rounded-lg animate-pulse mb-2"></div>
            <div className="w-full h-10 bg-[#2D4F71] rounded-lg animate-pulse mb-2"></div>
            <div className="w-full h-10 bg-[#2D4F71] rounded-lg animate-pulse mb-2"></div>
            <div className="w-full h-10 bg-[#2D4F71] rounded-lg animate-pulse mb-2"></div>
            <div className="w-full h-10 bg-[#2D4F71] rounded-lg animate-pulse mb-2"></div>
            <div className="w-full h-10 bg-[#2D4F71] rounded-lg animate-pulse mb-2"></div>
            <div className="w-full h-10 bg-[#2D4F71] rounded-lg animate-pulse mb-2"></div>
            <div className="w-full h-10 bg-[#2D4F71] rounded-lg animate-pulse mb-2"></div>
            <div className="w-full h-10 bg-[#2D4F71] rounded-lg animate-pulse mb-2"></div>
            <div className="w-full h-10 bg-[#2D4F71] rounded-lg animate-pulse mb-2"></div>
            <div className="w-full h-10 bg-[#2D4F71] rounded-lg animate-pulse mb-2"></div>
            <div className="w-full h-10 bg-[#2D4F71] rounded-lg animate-pulse mb-2"></div>
        </div>
    )
}

export default Skeleton